// Générateur de 150 témoignages pour Marseille
export const generateTestimonials = () => {
  const names = [
    'Marie L.', 'Thomas B.', 'Fatou S.', 'Sophie D.', 'Ahmed K.', 'Christine P.', 'Jean-Pierre M.',
    'Nadia R.', 'Laurent V.', 'Isabelle M.', 'Patrick G.', 'Sandra K.', 'Olivier N.', 'Leila B.',
    'Marc D.', 'Julie R.', 'Philippe A.', 'Carla M.', 'Antoine S.', 'Yasmine H.', 'François B.',
    'Amina T.', 'David C.', 'Samira D.', 'Pierre L.', 'Khadija M.', 'Alexandre R.', 'Rachida K.',
    'Nicolas F.', 'Fatima Z.', 'Julien P.', 'Malika B.', 'Maxime D.', 'Siham L.', 'Romain M.',
    'Zineb A.', 'Sébastien G.', 'Houria S.', 'Christophe V.', 'Sabrina M.', 'Vincent T.', 'Nora F.',
    'Mathieu L.', 'Imane K.', 'Damien R.', 'Hanane B.', 'Benjamin S.', 'Latifa D.', 'Lucas M.',
    'Karima H.'
  ];

  const locations = [
    'Marseille 1er', 'Marseille 2ème', 'Marseille 3ème', 'Marseille 4ème',
    'Marseille 5ème', 'Marseille 6ème', 'Marseille 7ème', 'Marseille 8ème',
    'Marseille 9ème', 'Marseille 10ème', 'Marseille 11ème', 'Marseille 12ème',
    'Marseille 13ème', 'Marseille 14ème', 'Marseille 15ème', 'Marseille 16ème',
    'Aix-en-Provence', 'Aubagne', 'La Ciotat', 'Martigues'
  ];

  const categories = [
    { name: 'Retour Affectif', weight: 40, messages: [
      'Mon mari est revenu après 8 mois de séparation. Maître Diamma est incroyable.',
      'Mon ex est revenu en moins de 2 semaines. Je recommande à 100%.',
      'Après 1 an de rupture, nous sommes à nouveau ensemble. Merci Maître Diamma.',
      'Mon couple est sauvé grâce à Maître Diamma. On était au bord du divorce.',
      'Il est revenu après 3 mois. Maître Diamma est le meilleur.',
      'Séparés depuis 6 mois, nous sommes remariés grâce à Maître Diamma.',
      'Mon compagnon est revenu encore plus amoureux. Résultats incroyables.'
    ]},
    { name: 'Voyance', weight: 15, messages: [
      'Tout ce que Maître Diamma a prédit s\'est réalisé. Un vrai don.',
      'Voyance précise et bienveillante. Maître Diamma m\'a aidée.',
      'Les prédictions se sont toutes réalisées. Impressionnant.'
    ]},
    { name: 'Travail', weight: 20, messages: [
      'J\'ai décroché un CDI en 3 semaines après la consultation.',
      'Réussi mon permis du premier coup après 4 échecs. Merci !',
      'Promotion obtenue 3 semaines après. Maître Diamma avait raison.',
      'J\'ai trouvé un CDI en moins d\'un mois comme prédit.'
    ]},
    { name: 'Protection', weight: 15, messages: [
      'Libérée de mon envoûtement. Je me sens légère maintenant.',
      'Plus aucun problème depuis la protection spirituelle.',
      'Les blocages ont disparu. Je revis enfin.'
    ]},
    { name: 'Chance', weight: 10, messages: [
      'Gagné 8,500€ après le rituel. La chance a tourné !',
      'Mon commerce a doublé son chiffre d\'affaires.',
      'Les opportunités arrivent depuis le rituel de chance.'
    ]}
  ];

  const timeframes = [
    'il y a 1 semaine', 'il y a 2 semaines', 'il y a 3 semaines', 'il y a 1 mois',
    'il y a 2 mois', 'il y a 3 mois'
  ];

  const testimonials = [];
  let nameCounter = 0;

  for (let i = 0; i < 150; i++) {
    const rand = Math.random() * 100;
    let cumulative = 0;
    let selectedCategory;

    for (const cat of categories) {
      cumulative += cat.weight;
      if (rand < cumulative) {
        selectedCategory = cat;
        break;
      }
    }

    const message = selectedCategory.messages[Math.floor(Math.random() * selectedCategory.messages.length)];
    const name = names[nameCounter % names.length];
    const location = locations[Math.floor(Math.random() * locations.length)];
    const timeframe = timeframes[Math.floor(Math.random() * timeframes.length)];
    const likes = Math.floor(Math.random() * 150) + 20;

    testimonials.push({
      id: i + 1,
      name: name,
      initial: name.charAt(0),
      location: location,
      date: timeframe,
      category: selectedCategory.name,
      rating: 5,
      text: message,
      likes: likes
    });

    nameCounter++;
  }

  return testimonials;
};

export const testimonials = generateTestimonials();
